// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDw7wh_XaSM_t6TtF8ocpLqNIeAzeUH8BM",
    authDomain: "chat-app-react-35ddd.firebaseapp.com",
    projectId: "chat-app-react-35ddd",
    storageBucket: "chat-app-react-35ddd.appspot.com",
    messagingSenderId: "701098181151",
    appId: "1:701098181151:web:5216353c9d5c2a62878b2a"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

